import React from 'react';
import { Icon } from '../../icon';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { has } from '../../../services';
const SelectNative = ({ selecteClasses, onChange, onFocus, onBlur, id, name, disabled, children, label, iconName, styled, testId, accessibilityLabel, selected, ...others }) => {
    const controlClasses = React.useMemo(() => hashClass(styled, clsx('control', has('dynamic-placeholder'))), [styled]);
    return (React.createElement("div", { className: hashClass(styled, clsx('field')) },
        React.createElement("div", { className: controlClasses },
            React.createElement("div", { className: selecteClasses },
                iconName && React.createElement(Icon, { name: iconName, size: 'small' }),
                React.createElement("select", { className: hashClass(styled, clsx(!label && 'no-label')), value: selected, "aria-label": accessibilityLabel, "data-testid": testId, onChange: (e) => {
                        if (onChange) {
                            onChange({
                                selectValue: e.target.value,
                                selectName: e.target.name,
                                selectId: e.target.id,
                                name: e.target.name,
                            });
                        }
                    }, onFocus: onFocus, onBlur: onBlur, id: id ? String(id) : undefined, name: name, disabled: disabled, ...others }, children),
                label && React.createElement("label", { htmlFor: id }, label)))));
};
export default SelectNative;
//# sourceMappingURL=SelectNative.js.map